<template>
    <div>
        <div class="add-content">
            <add-content @add="comp => addBlock(comp, 0)"/>
        </div>
<!--        <draggable v-model="blocks" handle=".drag-handle">-->
<!--            <transition-group>-->
                <div v-for="(block, i) in blocks" :key="block.keyId">
                    <div class="content-block">
                        <div class="content-block-component">
                            <component
                                :is="block.component"
                                :data="block.content"
                                @save="(d) => block.content = d"
                            ></component>
                        </div>
                        <div class="content-block-controls">
                            <b-button size="is-small" class="mr-2" @click="deleteBlock(i)"><i class="fal fa-trash-alt"></i></b-button>
<!--                            <i class="fas fa-sort drag-handle"></i>-->
                        </div>
                    </div>

                    <div class="add-content">
                        <add-content @add="comp => addBlock(comp, i+1)"/>
                    </div>
                </div>
<!--            </transition-group>-->
<!--        </draggable>-->
    </div>
</template>

<script>
    import AddContent from '@/components/editor/AddContent';

    import OneColumnText from '@/components/editor/content_blocks/OneColumnText';
    import TwoColumnText from '@/components/editor/content_blocks/TwoColumnText';
    import ThreeColumnText from '@/components/editor/content_blocks/ThreeColumnText';
    import ExpanderText from '@/components/editor/content_blocks/ExpanderText';
    import Video from '@/components/editor/content_blocks/Video';
    import FlipCards from '@/components/editor/content_blocks/FlipCards';
    import PhotoAndText from '@/components/editor/content_blocks/PhotoAndText';
    import TextField from '@/components/editor/content_blocks/TextField';
    import TextArea from '@/components/editor/content_blocks/TextArea';
    import CheckBox from '@/components/editor/content_blocks/CheckBox';
    import DropdownField from '@/components/editor/content_blocks/DropdownField';
    import StudyRecordLog from '@/components/editor/content_blocks/StudyRecordLog';
    import ImageHotspot from '@/components/editor/content_blocks/ImageHotspot';
    import Message from '@/components/editor/content_blocks/Message';

    import draggable from "vuedraggable";

    export default {
        name: "ContentBlocks",
        components: {draggable, AddContent, OneColumnText, TwoColumnText, ThreeColumnText, ExpanderText, Video, FlipCards, ImageHotspot, PhotoAndText, TextField, TextArea, CheckBox, DropdownField, StudyRecordLog, Message},
        props: ['blocks'],
        data: function() {
            return {};
        },
        methods: {
            addBlock(component, index) {
                console.log(index);
                this.blocks.splice(index, 0, {
                    component,
                    content: {},
                    keyId: Math.random().toString(36).slice(2, 10)
                });
                // this.blocks.push({
                //     component,
                //     content: {}
                // });
            },
            deleteBlock(index) {
                if (window.confirm('Are you sure you want to delete this content?')) {
                    this.blocks.splice(index, 1);
                }
            }
        },
        created() {
            for (let i = 0; i < this.blocks.length; i++) {
                const block = this.blocks[i];
                block.keyId = Math.random().toString(36).slice(2, 10);
            }

            console.log(this.blocks);
        }
    };
</script>

<style lang="scss" scoped>
    .content-block {
        padding: 2px 0 2px 0;
        transition: border 500ms;
        display: flex;

        .content-block-controls {
            visibility: hidden;
            padding-left: 20px;
        }

        .content-block-component {
            flex: 1 1 0;
            border-radius: 6px;
            border: 1px solid transparent;
        }

        &:hover {
            .content-block-controls {
                visibility: visible;
            }

            .content-block-component {
                border: 1px solid #e7e7e7;
            }
        }
    }
</style>
